import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import ButtonIconSearch from '../../../../components/button/ButtonIconSearch'
import CardFooter from '../../../../components/card/CardFooter'
import Tdbody from '../../../../components/table/Tdbody'
import Thead from '../../../../components/table/Thead'
import { GetMyClientsWithOpenBarrelAccountApi } from '../../../../http/Services/BarrelAccountApi'

export default function ModalClientBarrelAccountList({
    show,
    handleClose,
    title,
    buttonText,
    variant,
    setClient,
    client
}) {
    const [clients, setClients] = useState([])
    // const [client, setClient] = useState({})
    const [orderBy, setOrderBy] = useState('id')
    const [orderByDesc, setOrderByDesc] = useState('ASC')
    const [typeQuery, setTypeQuery] = useState('nombre')
    const [forQuery, setForQuery] = useState('')

    let num = 1

    const ordered = (type) => {
        setOrderBy(type)
        setOrderByDesc(orderByDesc === "DESC" ? "ASC" : "DESC")
    }
    useEffect(() => {
        const getClients = async () => {
            try {
                let res = await GetMyClientsWithOpenBarrelAccountApi(1, 100, forQuery, typeQuery, orderBy, orderByDesc);
                if (res.status === 200) {
                    setClients(res.data)
                }
            } catch (error) {

            }
        }
        getClients()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forQuery, orderBy, orderByDesc])

    const selected = (data) => {
        setClient(data)
    }
    const unSelected = () => {
        setClient(null)
        handleClose()

    }
    return (
        <Modal show={show} onHide={handleClose} animation={true} >
            <Modal.Header closeButton>
                <Modal.Title className='h6 fw-bold text-secondary'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: 'center' }}>
                <div className="card">
                    <div className='col-12 mb-2 pt-2'>
                        <ButtonIconSearch
                            variant="danger"
                            placeholder="buscar cliente..."
                            setTypeQuery={setTypeQuery}
                            setForQuery={setForQuery}
                            reset={true}
                        />
                    </div>
                    <Table hover size="sm" className='mb-0' striped responsive style={{ border: '4px solid #495057' }}>
                        <Thead
                            columns={[
                                ["", () => ordered('id'), true],
                                ["Nombre", () => ordered('nombre'), true],
                                ["Saldo turril"],
                                ["Tipo"],
                                ["Fecha limite"],
                                ["Apertura"],
                            ]}
                        />
                        <tbody>
                            {
                                clients.data &&
                                clients.data.map((data) => (
                                    <tr key={data.id} style={{ cursor: 'pointer' }}
                                        onClick={() => selected(data)}
                                        className={client && client.id === data.id ? 'table-success fw-bold' : ''}
                                    >
                                        <Tdbody
                                            position='center'
                                            fsSmall='15px'
                                        >
                                            {clients.current_page === 1 ? num++ : (clients.current_page * 5 - 5 + num++)}

                                        </Tdbody>
                                        <Tdbody
                                            fsSmall='15px'
                                        >
                                            {data.nombre}{' '}
                                            {data.apellido_paterno}{' '}
                                            {data.apellido_materno}{' '}
                                        </Tdbody>
                                        <Tdbody
                                            fsSmall='15px'
                                        >
                                            {data.saldo_cantidad}{' '}
                                        </Tdbody>
                                        <Tdbody
                                            fsSmall='15px'
                                        >
                                            {data.metodo_vacio}
                                        </Tdbody>
                                        <Tdbody
                                            fsSmall='15px'
                                        >
                                            <small>{data.fecha_limite}</small>
                                        </Tdbody>
                                        <Tdbody
                                            fsSmall='15px'
                                        >
                                            <small>{data.created_at}</small>
                                        </Tdbody>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                    <div className="card-footer p-0 d-flex justify-content-end">
                        {/* <div className="col-3">
                            <CardFooter
                                total={'Páginas: ' + (clients.last_page ? clients.last_page : 0)}
                            />
                        </div> */}
                        <div className="col-3">
                            <CardFooter
                                total={'Total: ' + (clients.total ? clients.total : 0)}
                            />
                        </div>

                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="secondary" onClick={() => unSelected()} >
                    Cancelar
                </Button> */}
                {client &&
                    <Button variant="warning" onClick={() => unSelected()} >
                        Quitar
                    </Button>
                }
                <Button variant={variant} style={{ background: '#00bfa5', border: 'none' }} onClick={handleClose} disabled={client ? false : true}>
                    {buttonText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
